import Vue from "vue";
import App from "./App.vue";
import lodash from "lodash";
import VCalendar from "v-calendar";
import VueApexCharts from "vue-apexcharts";
import VueSvgGauge from "vue-svg-gauge";
// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCog,
  faFileImport,
  faFileInvoiceDollar,
  faFileUpload,
  faPlus,
  faReceipt,
  faTasks,
  faTrashAlt,
  faUsers,
  faUsersCog,
  faFilter,
  faSearch,
  faListUl,
  faUniversity,
  faUserCircle,
  faEdit,
  faExclamationTriangle,
  faTimes,
  faFileAlt,
  faTimesCircle,
  faFolder,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import BaseDialog from "./layouts/components/BaseDialog.vue";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VCalendar);
Vue.use(Vuesax);
Vue.use(VueSvgGauge);

// NOTE for font awesome
library.add(
  faTasks,
  faFileInvoiceDollar,
  faReceipt,
  faUsers,
  faUsersCog,
  faCog,
  faPlus,
  faTrashAlt,
  faFileUpload,
  faFileImport,
  faFilter,
  faSearch,
  faListUl,
  faUniversity,
  faUserCircle,
  faEdit,
  faExclamationTriangle,
  faTimes,
  faFileAlt,
  faTimesCircle,
  faFolder
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("base-dialog", BaseDialog);
// Optionally install the BootstrapVue icon components plugin

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// export excel
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

// html2pdf
// import html2pdf from "html2pdf.js";
// Vue.use(html2pdf);

// import html2canvas from "html2canvas";
// Vue.use(html2canvas);
//vue-lodash
import VueLodash from "vue-lodash";
Vue.use(VueLodash, { name: "custom", lodash: lodash });

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
